import React, { useEffect, useState } from "react"
import { Padder, ScreenHeader } from "../UI/Elements"
import { AdminIcons } from "../Shared/AdminIcon"
import { ApprovedPlantOriginModelApiType, usePlantOrigins } from "./usePlantOrigins";

export const PlantOrigins = () => {

    const ui = usePlantOrigins();

    const [list, setList] = useState<ApprovedPlantOriginModelApiType[]>([])
    const [editId, setEditId] = useState<string>();

    const [name, setName] = useState<string>();
    const [organizationId, setOrganizationId] = useState<string>();
    const [keywords, setKeywords] = useState<string>();

    const toggle = (e: string) => {
        if (e === editId) {
            setEditId(undefined);
            ui.getAllApproved().then(s => setList(s))
        } else {
            setEditId(e)
        }
    }


    useEffect(() => {
        ui.getAllApproved().then(s => setList(s));
        ui.organizationsLoad(undefined);
    }, []);

    const onAdd = async () => {
        await ui.addApproved({
            name: name,
            keywords: keywords,
            organizationId: organizationId
        });
        setName("");
        setKeywords("");
        setOrganizationId("");
        const d = await ui.getAllApproved();
        setList(d);
    }

    return (
        <div>
            <ScreenHeader text="Ursprung" icon={AdminIcons.leaf} />
            {/* <div>
                {JSON.stringify(ui.organizations)}
            </div> */}
            <div>
                <table className="tbl tbl-small">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Namn</th>
                            <th>Kund</th>
                            <th>nyckelord (kommaseparerade)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {list?.map((o, idx) => (
                            <tr key={o?.id}>
                                <td style={{ width: "50px" }}>{idx + 1}</td>
                                <td>
                                    {editId === o?.id && (
                                        <input type="text" className="frm" value={o?.name}
                                            onChange={e => {
                                                let change = [...list];
                                                change[idx].name = e.target.value;
                                                setList(change);
                                            }}
                                        />
                                    )}
                                    {!(editId === o?.id) && (
                                        <span>{o?.name}</span>
                                    )}
                                </td>

                                <td>

                                    {editId === o?.id && (
                                        <>
                                            <select className="frm" defaultValue={o?.organizationId} onChange={e => {
                                                let change = [...list];
                                                change[idx].organizationId = e.target.value;
                                                setList(change);
                                            }}>
                                                <option value={undefined}>-</option>
                                                {ui.organizations?.map(m => (
                                                    <option key={m?.id} value={m?.id}>{m?.name}</option>
                                                ))}
                                            </select>
                                        </>
                                    )}

                                    {!(editId === o?.id) && (
                                        <span>{!!o?.organizationId ? ui.organizations?.find(m => m?.id == o?.organizationId)?.name : ""}</span>
                                    )}
                                </td>

                                <td>
                                    {editId === o?.id && (
                                        <input type="text" className="frm" value={o?.keywords}
                                            onChange={e => {
                                                let change = [...list];
                                                change[idx].keywords = e.target.value?.toLowerCase();
                                                setList(change);
                                            }} />
                                    )}
                                    {!(editId === o?.id) && (
                                        <span>{o?.keywords}</span>
                                    )}
                                </td>
                                <tr>
                                    <button className="btn-link" onClick={() => toggle(o?.id)} >
                                        {editId === o?.id ? "Ångra" : "Ändra"}
                                    </button>

                                    {editId === o?.id && (
                                        <>
                                            <button className="btn-link" onClick={async () => {
                                                await ui.updateApproved(o);
                                                const d = await ui.getAllApproved();
                                                setList(d);
                                                setEditId(undefined);
                                            }} >
                                                Spara
                                            </button>


                                            <button className="btn-link btn-link-warning" onClick={async () => {
                                                await ui.deleteApproved(o?.id);
                                                const d = await ui.getAllApproved();
                                                setList(d);
                                                setEditId(undefined);
                                            }} >
                                                Radera
                                            </button>

                                        </>
                                    )}
                                </tr>
                            </tr>
                        ))}

                        <tr>
                            <td></td>
                            <td>
                                <input type="text" className="frm" value={name} onChange={e => setName(e.target.value)} />
                            </td>
                            <td>
                                <select className="frm" value={organizationId} onChange={e => setOrganizationId(e.target.value)}>
                                    <option value={undefined}>-</option>
                                    {ui.organizations?.map(m => (
                                        <option key={m?.id} value={m?.id}>{m?.name}</option>
                                    ))}
                                </select>
                            </td>
                            <td>
                                <input type="text" className="frm" value={keywords} onChange={e => setKeywords(e.target.value?.toLowerCase())} />
                            </td>
                            <tr>
                                <button className="btn-link" onClick={onAdd} >
                                    Lägg till
                                </button>
                            </tr>
                        </tr>
                    </tbody>
                </table>

                <Padder.Horizontal size="100px" />
            </div>
        </div>
    )
}